import { useLayoutEffect, useRef, useState } from "react";

// The width of the element behind `ref`, kept current with a ResizeObserver,
// or with window resizes in a browser without one. It stays at `fallback`
// only while the element reports no width (Jest's jsdom).
export const useContainerWidth = (fallback) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(fallback);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    // Read once before the first paint, so a narrow screen never flashes
    // the wide layout while the first observation is on its way.
    const read = () => el.clientWidth > 0 && setWidth(el.clientWidth);
    read();
    if (typeof window.ResizeObserver !== "function") {
      window.addEventListener("resize", read);
      return () => window.removeEventListener("resize", read);
    }
    const observer = new window.ResizeObserver(([entry]) => setWidth(Math.floor(entry.contentRect.width)));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, width];
};
